import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { environment } from '../../../environments/environment';

@Component({
    selector: 'watchface-card',
    templateUrl: './watchface-card.component.html',
    styleUrls: ['./watchface-card.component.scss']
})
export class WatchfaceCardComponent implements OnInit, OnDestroy {

    watchfacesStore: string;

    @Input()
    watchface: any;

    @Input()
    approve: boolean = true;

    @Input()
    reject: boolean = true;

    @Output('approve')
    approveEventEmitter = new EventEmitter<void>();

    @Output('reject')
    rejectEventEmitter = new EventEmitter<void>();

    constructor() {
        this.watchfacesStore = environment.watchfacesStore;
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    emitApproveEvent() {
        this.approveEventEmitter.emit();
    }

    emitRejectEvent() {
        this.rejectEventEmitter.emit();
    }
}
